import { render, staticRenderFns } from "./nonMerStep4.vue?vue&type=template&id=8c11a950&scoped=true&"
import script from "./nonMerStep4.vue?vue&type=script&lang=js&"
export * from "./nonMerStep4.vue?vue&type=script&lang=js&"
import style0 from "./nonMerStep4.vue?vue&type=style&index=0&id=8c11a950&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c11a950",
  null
  
)

export default component.exports